import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getNiveau1, getNiveau2, buildPath, TABLEAU_DE_BORD } from '../OAD/shared/navConfig';

/**
 * Frame Figma "Menu_OAD" : les deux premiers niveaux de navigation.
 *
 * Ligne 1 : Tableau de bord + les entrées de OAD_NAV.
 * Ligne 2 : les enfants du niveau 1 actif (absente sur le Tableau de bord).
 *
 * Rien n'est câblé en dur ici : tout vient de navConfig.js.
 *
 * idExploit reste transporté en state du routeur (Q2), donc chaque navigation
 * le repasse explicitement.
 */
export default function MenuOAD({ niveau1, niveau2, idExploit }) {
  const navigate = useNavigate();

  function allerA(path) {
    navigate(path, { state: { idExploit } });
  }

  return (
    <div className="menu-oad">
      <div className="menu-oad-ligne1">
        <button
          type="button"
          className={`menu-oad-onglet${!niveau1 ? ' menu-oad-onglet-actif' : ''}`}
          onClick={() => allerA(TABLEAU_DE_BORD.path)}
          disabled={!niveau1}
        >
          {TABLEAU_DE_BORD.label}
        </button>

        {getNiveau1().map((entree) => {
          const actif = entree.key === niveau1;
          return (
            <button
              key={entree.key}
              type="button"
              className={`menu-oad-onglet${actif ? ' menu-oad-onglet-actif' : ''}`}
              onClick={() => allerA(buildPath(entree.key))}
              disabled={actif}
            >
              {entree.label}
            </button>
          );
        })}
      </div>

      {niveau1 && (
        <div className="menu-oad-ligne2">
          {getNiveau2(niveau1).map((entree) => {
            const actif = entree.key === niveau2;
            return (
              <button
                key={entree.key}
                type="button"
                className={`menu-oad-sous-onglet${actif ? ' menu-oad-sous-onglet-actif' : ''}`}
                onClick={() => allerA(buildPath(niveau1, entree.key))}
                disabled={actif}
              >
                {entree.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
